<template>
  <div class="wait-list-card" ref="productCard">
    <a :href="link" @click="handleRedirect({e: $event, link})" class="wait-list-card__img-wrap">
      <img class="wait-list-card__img" :src="imageUrl" :alt="title">
      <img class="wait-list-card__img--hovered" :src="secondImageUrl" :alt="title">
      <!--      <img class="wait-list-card__img" src="https://static.dnipro-m.ua/cache/products/4015/thumb_328702.jpg" :alt="title">-->
      <!--      <img class="wait-list-card__img&#45;&#45;hovered" src="https://static.dnipro-m.ua/cache/products/5533/thumb_485971.jpg" :alt="title">-->
    </a>
    <div class="wait-list-card__info">
      <a :href="link" @click="handleRedirect({e: $event, link})" class="wait-list-card__title">{{ title }}</a>
      <div class="wait-list-card__price-wrap">
        <ProductPrice
          type="adaptive-main-page"
          v-if="showProductPrice"
          :price="getNewPrice"
          :old-price="getOldPrice"
          class="product-card__price"
        />
        <span
          v-else
          class="product-card__price product-card__price--not-available"
          :class="{ 'product-card__price--not-available-arrival': arrivalDate }"
        >{{ arrivalDate || $t('out_of_stock') }}</span>
        <BuyBtn
          v-if="isBuyButtonVisible"
          :title-ru="titleRu"
          :product-id="id"
          :code="code"
          :price="getNewPrice"
          :store-id="availableInStore ? availableInStore.store_id : ''"
          :esputnik-data="esputnikData"
          :esputnik-block-id="esutnikBlockId"
          :product-link="link"
          size="medium"
          class="wait-list-card__buy-btn"
        />
        <Button
          v-else
          :href="link"
          @click.native="handleRedirect({e: $event, link})"
          additional-type="detail-btn"
          type="plain">
          {{ $t('wait_list_detail_text') }}
        </Button>
      </div>
    </div>
    <wait-list-card-menu
      :product-data="{ ...$props }"
      :is-in-wish-list="isInWishList"
      @clickWishlist="addToWishList"
      @clickRemove="removeFromWaitList"
    ></wait-list-card-menu>
  </div>
</template>

<script>
import BuyBtn from '@/components/cart/BuyBtn.vue'
import ProductPrice from '@/components/product/ProductPrice.vue'
import Button from '@/components/inputs/Button.vue'
import WaitListCardMenu from '@/components/product/product-card/WaitListCardMenu.vue'
import * as Sentry from '@sentry/vue'
import { GoogleEnhancedEcommerce, GoogleTagManagerService } from '@/services/AnalyticService'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'WaitListCard',
  components: { Button, ProductPrice, BuyBtn, WaitListCardMenu },
  data () {
    return {
      pending: false
    }
  },
  props: {
    imageUrl: {
      type: String,
      required: false,
      default: ''
    },
    secondImageUrl: {
      type: String,
      required: false,
      default: ''
    },
    isPreorder: {
      type: Boolean,
      default: false
    },
    arrivalDate: [String, Boolean],
    titleRu: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: null
    },
    code: {
      type: String,
      default: ''
    },
    availableInStore: [Boolean, Object],
    esputnikData: Object,
    esutnikBlockId: String,
    link: {
      type: String,
      default: ''
    },
    inStock: {
      type: Boolean,
      default: undefined
    },
    price: {
      type: String,
      default: ''
    },
    withoutBuy: {
      type: Boolean,
      default: false
    },
    isAvailable: {
      type: Boolean,
      default: false
    },
    analyticsData: {
      type: Array,
      default: () => []
    },
    position: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters('wishlist', ['productsIdsInWishlist']),
    isInWishList () {
      return this.productsIdsInWishlist.length ? this.productsIdsInWishlist.includes(this.id) : false
    },
    priceObject: function () {
      return JSON.parse(this.price)
    },
    showProductPrice () {
      return (this.isAvailable && this.getNewPrice) || (this.availableInStore && this.getNewPrice) || (this.isPreorder && this.getNewPrice)
    },
    getNewPrice () {
      return +this.priceObject.price_new ?? null
    },
    getOldPrice () {
      return this.priceObject.price_old && this.priceObject.price_old !== this.priceObject.price_new
        ? +this.priceObject.price_old
        : null
    },
    isBuyButtonVisible () {
      // параметр inStock на данный момент (21.01.22) прокидывается только в вишлисте.
      if (this.isPreorder || (this.inStock !== undefined && this.inStock === false && !this.availableInStore)) {
        return false
      }
      return this.priceObject.price_new && !this.withoutBuy && (this.isAvailable || this.availableInStore)
    }
  },
  methods: {
    ...mapActions('wishlist', ['CHANGE_WISH_LIST_STATUS']),
    ...mapActions('waitlist', ['CHANGE_WAIT_LIST_STATUS']),
    notifySuccess (message) {
      this.$notify({
        group: 'success',
        text: message,
        type: 'success'
      })
    },
    notifyError (message) {
      this.$notify({
        group: 'error',
        text: message,
        type: 'error'
      })
    },
    addToWishList () {
      if (!this.pending) {
        this.pending = true
        this.CHANGE_WISH_LIST_STATUS({
          id: this.id,
          code: this.code,
          price: this.getNewPrice,
          isInStock: this.inStock
        })
          .then(() => {
            if (GoogleEnhancedEcommerce.isEnabled) {
              GoogleEnhancedEcommerce.addToWishlist({
                value: +GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0]).price * parseInt(GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0]).quantity || 1),
                universal_value: this.isInWishList ? 'add' : 'removed',
                items: [GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0])]
              })
            }
            this.pending = false
            this.removeFromWaitList()
          })
          .catch(error => {
            this.notifyError(error)
            this.pending = false
          })
      }
    },
    removeFromWaitList () {
      if (!this.pending) {
        let postData = {
          product_id: this.id,
          remove: 1
        }
        this.pending = true

        this.CHANGE_WAIT_LIST_STATUS({ postData: postData })
          .then(response => {
            this.pending = false
            this.notifySuccess(response.message)
          })
          .catch(error => {
            this.notifyError(error)
          })
      }
    },
    checkIfProductFromBannerLink () {
      const savedBanners = JSON.parse(localStorage.getItem('clickedBanners')) || []
      const currPathWithoutLang = window.location.pathname.replace('/uk/', '/')
      const currBanner = savedBanners.find(el => el.banner_link.includes(currPathWithoutLang))
      if (currBanner) {
        const bannerPromoItems = JSON.parse(localStorage.getItem('bannerPromoItems')) || {}
        if (!Array.isArray(bannerPromoItems[currBanner.promotion_id])) {
          bannerPromoItems[currBanner.promotion_id] = []
        }
        if (!bannerPromoItems[currBanner.promotion_id].find(el => el.toString() === this.computedCode.toString())) {
          bannerPromoItems[currBanner.promotion_id].push(this.computedCode)
        }
        localStorage.setItem('bannerPromoItems', JSON.stringify(bannerPromoItems))
      }
    },
    async handleRedirect (event) {
      const { e, link } = event
      e.preventDefault()

      const analyticsData = this.analyticsData.map(item => {
        if (item.hasOwnProperty('quantity')) delete item.quantity

        return { ...item, position: this.position }
      })

      for (let item of analyticsData) {
        if (!item.id) {
          Sentry.captureMessage('Empty analytics data item', {
            extra: { analyticsData },
            tags: { category: 'analytics' }
          })
        }
      }
      if (GoogleEnhancedEcommerce.isEnabled) {
        await GoogleEnhancedEcommerce.selectItem({
          'items': [GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0])]
        })
      } else {
        await GoogleTagManagerService.productClickEvent({
          analyticsData,
          actionField: {
            'list': 'cabinet_wait_list'
          }
        })
      }
      location.href = link
    }
  },
  mounted () {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.checkIfProductFromBannerLink()
          if (this.$parent && this.$parent.collectAnalyticsData) {
            if (GoogleEnhancedEcommerce.isEnabled) {
              let GEEdata = this.analyticsData[0]
              this.$parent.collectAnalyticsData(GEEdata)
            }
          }
          if (GoogleEnhancedEcommerce.isEnabled) {
            this.$emit('onIntersecting', GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0]))
          }

          // observer.unobserve(this.$refs.productCard)
        }
      },
      { threshold: 0.2 }
    )
    observer.observe(this.$refs.productCard)
  }
}
</script>

<style lang="sass">
.wait-list-card
  height: 100%
  .product-price
    margin-bottom: 15px
  &__buy-btn
    max-width: 215px
    text-align: center
    button
      width: 100%
      justify-content: center
    .add-to-cart__svg-wrap
      display: none
</style>
<style lang="sass" scoped>
.vue-button--detail-btn
  max-width: 215px
  text-align: center
  font-size: 14px
  padding: 10px 30px
.product-card__price
  &--not-available
    color: #909090
    font-size: 14px
    line-height: 1.25
    padding-left: 25px
    position: relative
    margin-bottom: 20px
    display: inline-block
    &:before
      content: ''
      position: absolute
      left: 0
      top: 50%
      transform: translateY(-50%)
      width: 15px
      height: 15px
      background-image: url("/img/svgo/calendar.svg")
      background-repeat: no-repeat
      background-position: center
.wait-list-card
  display: flex
  padding: 15px 20px
  border: 1px solid #F3F3F3
  border-radius: 3px
  align-items: flex-start
  +mbetween($tablet--hor, $large)
    padding: 15px
  +mmax($extsmall--hor)
    padding: 15px
  &__info
    flex-grow: 1
    padding-right: 8px
  &__title
    font-size: 16px
    line-height: 24px
    color: #333
    text-decoration: none
    margin-bottom: 8px
    display: block
  &__img
    display: block
    &--hovered
      display: none
  &__img-wrap
    width: 108px
    height: 108px
    flex-shrink: 0
    position: relative
    margin-right: 30px
    font-size: 12px
    +mbetween($tablet--hor, $large)
      width: 80px
      height: 80px
      margin-right: 15px
    +mmax($extsmall--hor)
      width: 80px
      height: 80px
      margin-right: 15px
    img
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      max-height: 100%
    &:hover
      .wait-list-card__img
        display: none
      .wait-list-card__img--hovered
        display: block
</style>
